export const BASE_URL = process.env.BASE_URL;
export const API_BASE_URL = process.env.VUE_APP_API_ROOT;
export const API_GATEWAY_URL = process.env.VUE_APP_API_ROOT;
export const GA_TRACKING_ID = process.env.VUE_APP_GA_TRACKING_ID;
